import { Edit, SimpleForm, TextInput, useNotify } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import { jsonFormat, jsonParse, validateJsonObject } from '../../lib/jsonInput';

const BusinessRulesTemplatesEdit = () => {
  const navigate = useNavigate();
  const notify = useNotify();
  return (
    <Edit
      mutationMode="pessimistic"
      mutationOptions={{
        onSuccess: () => {
          notify('Saved');
          navigate(-1);
        }
      }}
    >
      <SimpleForm>
        <TextInput disabled source="uuid" label="UUID" />
        <TextInput disabled source="country" label="Country code" />
        <TextInput disabled source="type" label="Rule type" />
        <TextInput source="template" label="Template (JSON)" multiline fullWidth minRows={15} format={jsonFormat} parse={jsonParse} validate={validateJsonObject} helperText="Valid JSON object — this becomes the default for new companies in this country" />
      </SimpleForm>
    </Edit>
  );
};

export default BusinessRulesTemplatesEdit;
